export default {
  operationSuccess: 'Profile is successfully updated.',
  saveError: 'There was error in the system. Please try again.',
};
